export const version = "signing-key/5.6.1";
//# sourceMappingURL=_version.js.map